import { render, staticRenderFns } from "./DidntReturnStaffTable.vue?vue&type=template&id=30a820ab&scoped=true"
import script from "./DidntReturnStaffTable.vue?vue&type=script&lang=js"
export * from "./DidntReturnStaffTable.vue?vue&type=script&lang=js"
import style0 from "./DidntReturnStaffTable.vue?vue&type=style&index=0&id=30a820ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a820ab",
  null
  
)

export default component.exports